/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SpotMeGear = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2 9.65559C2 4.7955 6.56483 1 12 1C17.4352 1 22 4.7955 22 9.65559V11.4189L18.5 15.2634L17.3751 14.2502L20.2071 11.1394H3.7929L6.62488 14.2502L5.5 15.2634L2 11.4189V9.65559ZM10.044 2.67506C6.26297 3.43006 3.53846 6.32546 3.53846 9.65559H7.1282V9.5708C7.1282 6.87205 8.24321 4.42003 10.044 2.67506ZM15.3334 9.5708V9.65559H8.66667V9.5708C8.66667 6.84524 9.98821 4.45507 12 2.99601C14.0118 4.45507 15.3334 6.84523 15.3334 9.5708ZM16.8718 9.5708C16.8718 6.87205 15.7568 4.42003 13.9561 2.67507C17.737 3.43007 20.4615 6.32547 20.4615 9.65559H16.8718V9.5708Z"
                        fill={color}
                    />
                    <path
                        d="M11.54 12.6504H12.46C12.7156 12.6504 12.8594 12.836 12.8594 12.9893V13.5C12.8594 14.5031 13.9759 15.0385 14.8047 14.5918L14.8037 14.5908L15.2773 14.3359C15.488 14.2223 15.7421 14.3026 15.8438 14.4658V14.4668L16.3037 15.21V15.2109C16.3902 15.3509 16.3567 15.5487 16.1631 15.6533L15.6895 15.9082C14.8024 16.3865 14.8026 17.6137 15.6895 18.0918L16.1631 18.3467C16.3321 18.4381 16.3791 18.6017 16.3301 18.7354L16.3037 18.79L15.8438 19.5342C15.7551 19.677 15.5498 19.7568 15.3584 19.6982L15.2773 19.6641L14.8037 19.4092C13.975 18.9627 12.8597 19.4973 12.8594 20.5V21.0107C12.8594 21.1638 12.7157 21.3496 12.46 21.3496H11.54C11.2844 21.3496 11.1406 21.164 11.1406 21.0107V20.5C11.1406 19.4969 10.0247 18.9623 9.19629 19.4082L9.19531 19.4092L8.72168 19.6641C8.51087 19.7775 8.2566 19.697 8.15527 19.5332L7.69629 18.79L7.66992 18.7344C7.62112 18.6011 7.66812 18.4387 7.83691 18.3477L8.31055 18.0918C9.14239 17.6433 9.19394 16.5373 8.4668 16.0068L8.31055 15.9092L7.83691 15.6533C7.64348 15.5489 7.60971 15.3512 7.69629 15.2109V15.21L8.15527 14.4658L8.15625 14.4668C8.25747 14.3032 8.5115 14.2221 8.72266 14.3359L9.19531 14.5908V14.5918C10.0242 15.0386 11.1406 14.503 11.1406 13.5V12.9893C11.1406 12.8362 11.2843 12.6504 11.54 12.6504Z"
                        stroke={color}
                        strokeWidth="1.3"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12 18.5C12.8284 18.5 13.5 17.8284 13.5 17C13.5 16.1716 12.8284 15.5 12 15.5C11.1716 15.5 10.5 16.1716 10.5 17C10.5 17.8284 11.1716 18.5 12 18.5Z"
                        fill={color}
                    />
                </svg>
        );
    };
